import { render, staticRenderFns } from "./CreateEditPreview.vue?vue&type=template&id=64ee9647&scoped=true"
import script from "./CreateEditPreview.vue?vue&type=script&lang=js"
export * from "./CreateEditPreview.vue?vue&type=script&lang=js"
import style0 from "./CreateEditPreview.vue?vue&type=style&index=0&id=64ee9647&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ee9647",
  null
  
)

export default component.exports